import React, { useState } from "react";
import PropTypes from "prop-types";

import { Result, Button, Dropdown } from "antd";
import { DropboxOutlined } from "@ant-design/icons";

const propTypes = {
    estado: PropTypes.string.isRequired,
    templates: PropTypes.array,
    onCreate: PropTypes.func,
};

const defaultProps = {
    estado: true,
    templates: [],
    loading: false,
};

const App = ({ estado, loading, onCreate, allowToCreate, templates }) => {
    if (estado === "STORAGE_NOT_CREATED") {
        if ((templates || []).length > 0) {
            const blankItem = { id: 0, name: "Blank" };
            let rtemplates = (templates || []).slice();
            rtemplates.push(blankItem);
            const items = rtemplates.map((item) => {
                return {
                    key: item.id,
                    label: (
                        <Button
                            size="small"
                            type="link"
                            style={{ color: "rgb(64, 169, 255)" }}
                            key={item.id.toString()}
                            onClick={() => onCreate({ template_id: item.id })}
                            disable={loading}
                            loading={loading}
                        >
                            Create using template {item.name}
                        </Button>
                    ),
                };
            });

            return (
                <Result
                    status="info"
                    title="Folder does not exist."
                    subTitle="Please create the folder first before upload files."
                    extra={[
                        <Dropdown.Button
                            loading={loading}
                            key="create"
                            type="primary"
                            disable={loading}
                            menu={{
                                items,
                            }}
                            style={{ display: "inherit" }}
                        >
                            Create
                        </Dropdown.Button>,
                    ]}
                />
            );
        }

        return (
            <Result
                status="info"
                title="Folder does not exist."
                subTitle="Please create the folder first before upload files."
                extra={[
                    <Button type="primary" key="create" onClick={onCreate} disable={loading} loading={loading}>
                        Create folder!
                    </Button>,
                ]}
            />
        );
    }
    return (
        <Result
            status="info"
            title="Folder does not exist."
            subTitle="If you need this folder, ask someone with privileges to create it."
        />
    );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
